<template>
  <div class="listBox">
    <!-- ===== 顶部统计卡片 ===== -->
    <ul class="statsBox" style="display: flex; gap: 15px; margin-bottom: 10px">
      <li
        v-for="st in state.stats"
        :key="st.key"
        class="statCard"
        :style="{ borderTopColor: st.color }"
        @click="onStatFilter(st.key)"
      >
        <text class="statNum" :style="{ color: st.color }">{{ st.count }}</text>
        <text class="statLabel">{{ st.label }}</text>
      </li>
    </ul>

    <!-- ===== 登录状态栏 ===== -->
    <ul
      class="sBox"
      style="
        margin-bottom: 5px;
        align-items: center;
        justify-content: space-between;
      "
    >
      <li style="display: flex; align-items: center; gap: 12px">
        <span style="font-weight: 600; font-size: 14px">
          数电发票列表
        </span>
        <el-tag v-if="state.isLoggedIn" type="success" size="small">
          <el-icon style="margin-right: 3px"><CircleCheckFilled /></el-icon>
          已登录
        </el-tag>
        <el-tag v-else type="danger" size="small">
          <el-icon style="margin-right: 3px"><WarningFilled /></el-icon>
          未登录
        </el-tag>
        <span v-if="state.accountId" style="color: #999; font-size: 12px">
          accountId: {{ state.accountId }}
        </span>
      </li>
      <li style="display: flex; gap: 8px">
        <el-button
          v-if="!state.isLoggedIn"
          type="primary"
          size="small"
          @click="onOpenQrLogin()"
        >
          扫码登录
        </el-button>
        <el-button
          v-if="state.isLoggedIn"
          type="warning"
          size="small"
          :loading="state.logoutLoading"
          @click="onLogout()"
        >
          退出登录
        </el-button>
        <el-button
          type="primary"
          size="small"
          plain
          @click="onRefreshLogin()"
        >
          刷新登录状态
        </el-button>
      </li>
    </ul>

    <!-- ===== 查询条件 ===== -->
    <ul class="sBox">
      <li style="flex: 1; display: flex; flex-wrap: wrap; gap: 8px">
        <el-select
          v-model="state.params.Params.ZhuangTai"
          placeholder="开票状态"
          clearable
          style="width: 130px"
          @change="onLoad()"
        >
          <el-option label="待开票" :value="0"></el-option>
          <el-option label="开票中" :value="1"></el-option>
          <el-option label="已开票" :value="2"></el-option>
          <el-option label="开票失败" :value="3"></el-option>
          <el-option label="已红冲" :value="4"></el-option>
          <el-option label="红冲失败" :value="5"></el-option>
        </el-select>
        <el-select
          v-model="state.params.Params.FaPiaoLeiXingDaiMa"
          placeholder="发票类型"
          clearable
          style="width: 130px"
          @change="onLoad()"
        >
          <el-option label="数电专票" value="032"></el-option>
          <el-option label="数电普票" value="030"></el-option>
        </el-select>
        <el-input
          v-model="state.params.Params.Key"
          style="width: 200px"
          placeholder="搜索客户/发票号码/流水号/订单号"
          clearable
          @clear="
            delete state.params.Params.Key;
            onLoad();
          "
        ></el-input>
        <el-input
          v-model="state.params.Params.GuanLianDingDanHao"
          style="width: 180px"
          placeholder="关联订单号"
          clearable
          @clear="
            delete state.params.Params.GuanLianDingDanHao;
            onLoad();
          "
        ></el-input>
        <el-date-picker
          v-model="state.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开票开始"
          end-placeholder="开票截止"
          value-format="YYYY-MM-DD"
          style="width: 260px"
          @change="onDateRangeChange"
        />
        <el-dropdown
          split-button
          type="primary"
          @click="onLoad()"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
      <li style="display: flex; align-items: center; gap: 8px">
        <el-button
          v-if="state.selection.length > 0"
          type="success"
          @click="onBatchIssue()"
          :loading="state.batchIssuing"
          :disabled="!state.isLoggedIn"
        >
          批量开票({{ state.selection.length }})
        </el-button>
        <el-button
          v-if="state.selection.length > 0"
          type="warning"
          plain
          @click="onBatchDownload()"
          :disabled="!state.isLoggedIn"
        >
          批量下载({{ state.selection.length }})
        </el-button>
      </li>
    </ul>

    <!-- ===== 表格 ===== -->
    <ul class="tBox">
      <el-table
        ref="domTable"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.Order,
          order: state.params.Asc == false ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @selection-change="onSelectionChange"
      >
        <el-table-column fixed type="selection" width="40" align="center" />

        <el-table-column
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.PageIndex - 1) * state.params.PageSize + index + 1
          "
          align="center"
        />

        <el-table-column
          prop="ZhuangTai"
          sortable="ZhuangTai"
          label="状态"
          width="100"
          align="center"
        >
          <template #default="{ row }">
            <el-tag
              v-if="row.ZhuangTai === 0"
              type="info"
              size="small"
            >待开票</el-tag>
            <el-tag
              v-else-if="row.ZhuangTai === 1"
              type="warning"
              size="small"
            >开票中</el-tag>
            <el-tag
              v-else-if="row.ZhuangTai === 2"
              type="success"
              size="small"
            >已开票</el-tag>
            <el-tag
              v-else-if="row.ZhuangTai === 3"
              type="danger"
              size="small"
            >开票失败</el-tag>
            <el-tag
              v-else-if="row.ZhuangTai === 4"
              type="warning"
              size="small"
            >已红冲</el-tag>
            <el-tag
              v-else-if="row.ZhuangTai === 5"
              type="danger"
              size="small"
            >红冲失败</el-tag>
            <el-tag v-else type="info" size="small">未知</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="FaPiaoLiuShuiHao"
          sortable="FaPiaoLiuShuiHao"
          label="发票流水号"
          width="180"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.Params.Key)
          "
        />

        <el-table-column
          prop="GuanLianDingDanHao"
          label="关联订单号"
          width="160"
          :formatter="
            (row, column, cellValue) => {
              if (!cellValue) return $tab_TextFormat('-');
              return $tab_Highlinght(cellValue, state.params.Params.GuanLianDingDanHao || state.params.Params.Key);
            }
          "
        />

        <el-table-column
          prop="GouFangMingCheng"
          label="客户/抬头"
          min-width="160"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.Params.Key)
          "
        />

        <el-table-column
          prop="GouFangShuiHao"
          label="购方税号"
          min-width="140"
        />

        <el-table-column
          prop="FaPiaoLeiXingDaiMa"
          sortable="FaPiaoLeiXingDaiMa"
          label="发票类型"
          width="100"
          align="center"
        >
          <template #default="{ row }">
            <el-tag
              v-if="row.FaPiaoLeiXingDaiMa === '032'"
              type="primary"
              size="small"
            >专票</el-tag>
            <el-tag v-else type="success" size="small">普票</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="FanHuiFaPiaoHaoMa"
          label="发票号码"
          width="160"
          :formatter="
            (row, column, cellValue) => {
              if (!cellValue) return $tab_TextFormat('-');
              return $tab_Highlinght(cellValue, state.params.Params.Key);
            }
          "
        />

        <el-table-column
          prop="HeJiJinE"
          sortable="HeJiJinE"
          label="合计金额"
          width="110"
          align="right"
          :formatter="(row, column, cellValue) => $tab_MoneyFormat(cellValue)"
        />

        <el-table-column
          prop="HeJiShuiE"
          sortable="HeJiShuiE"
          label="合计税额"
          width="110"
          align="right"
          :formatter="(row, column, cellValue) => $tab_MoneyFormat(cellValue)"
        />

        <el-table-column
          prop="JiaShuiHeJi"
          sortable="JiaShuiHeJi"
          label="价税合计"
          width="120"
          align="right"
          :formatter="(row, column, cellValue) => $tab_MoneyFormat(cellValue)"
        />

        <el-table-column
          prop="FanHuiKaiPiaoRiQi"
          sortable="FanHuiKaiPiaoRiQi"
          label="开票日期"
          width="130"
          align="center"
          :formatter="(row) => $tab_TextFormat(row.FanHuiKaiPiaoRiQi, '-')"
        />

        <el-table-column
          prop="KaiPiaoRen"
          label="开票人"
          width="80"
          align="center"
          :formatter="(row) => $tab_TextFormat(row.KaiPiaoRen, '-')"
        />

        <el-table-column
          prop="ShiBaiYuanYin"
          label="失败原因"
          min-width="150"
          :formatter="(row) => $tab_TextFormat(row.ShiBaiYuanYin, '-')"
        />

        <el-table-column
          prop="Cjsj"
          sortable="Cjsj"
          label="创建信息"
          width="160"
          :formatter="(row) => $tab_GroupFormat(row.CjrXm, row.Cjsj)"
        />

        <el-table-column
          label="操作"
          width="320"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <!-- 待开票/开票失败：可以开票 -->
            <el-button
              v-if="row.ZhuangTai === 0 || row.ZhuangTai === 3"
              type="success"
              :icon="Finished"
              link
             :disabled="!state.isLoggedIn"
              @click="onIssueSingle(row)"
            >
              开票
            </el-button>
            <!-- 已开票：可以红冲 -->
            <el-button
              v-if="row.ZhuangTai === 2"
              type="warning"
              :icon="Warning"
              link
              :disabled="!state.isLoggedIn"
              @click="onRedInvoice(row)"
            >
              红冲
            </el-button>
            <!-- 已开票：换开（未被红冲时显示） -->
            <el-button
              v-if="row.ZhuangTai === 2 && row.HongChongZhuangTai === 0"
              type="primary"
              :icon="Refresh"
              link
              :disabled="!state.isLoggedIn"
              @click="onHuanKai(row)"
            >
              换开
            </el-button>
            <!-- 已开票/已红冲：可以下载 -->
            <el-button
              v-if="row.PdfXiaZaiUrl || row.ZhuangTai === 2"
              type="primary"
              :icon="Download"
              link
              @click="onDownload(row)"
            >
              下载
            </el-button>
            <!-- 查看详情 -->
            <el-button
              type="primary"
              :icon="View"
              link
              @click="onViewDetail(row)"
            >
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.PageIndex"
        @onLoad="
          (pageIndex) => {
            state.params.PageIndex = pageIndex;
            onLoad();
          }
        "
      />
    </ul>

    <!-- ===== 扫码登录弹窗 ===== -->
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showQrLogin"
        title="怜花扫码登录"
        width="550px"
        @close="onCloseQrLogin()"
      >
        <div
          style="
            padding: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
          "
        >
          <!-- 二维码图片 -->
          <div
            v-loading="state.qrcodeLoading"
            style="
              width: 220px;
              height: 220px;
              border: 1px dashed #d9d9d9;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #fafafa;
              border-radius: 4px;
            "
          >
            <img
              v-if="state.qrcodeUrl"
              :src="state.qrcodeUrl"
              style="width: 200px; height: 200px"
              alt="登录二维码"
            />
            <el-icon v-else size="50" color="#c0c4cc"><PictureFilled /></el-icon>
          </div>

          <!-- 状态提示 -->
          <div v-if="state.loginStatus === 'waiting'" style="text-align: center">
            <el-icon
              class="is-loading"
              color="#409eff"
              size="20"
              style="margin-right: 5px"
            ><Loading /></el-icon>
            <span style="color: #409eff">等待扫码...</span>
          </div>
          <div v-else-if="state.loginStatus === 'scanned'" style="text-align: center">
            <el-icon color="#e6a23c" size="20" style="margin-right: 5px"
              ><Clock /></el-icon>
            <span style="color: #e6a23c">请在手机上确认登录</span>
          </div>
          <div v-else-if="state.loginStatus === 'success'" style="text-align: center">
            <el-icon color="#67c23a" size="20" style="margin-right: 5px"
              ><CircleCheckFilled /></el-icon>
            <span style="color: #67c23a">登录成功！正在刷新...</span>
          </div>
          <div v-else-if="state.loginStatus === 'error'" style="text-align: center">
            <el-icon color="#f56c6c" size="20" style="margin-right: 5px"
              ><CircleCloseFilled /></el-icon>
            <span style="color: #f56c6c">{{ state.loginError }}</span>
          </div>
          <div v-else-if="state.loginStatus === 'expired'" style="text-align: center">
            <el-icon color="#f56c6c" size="20" style="margin-right: 5px"
              ><CircleCloseFilled /></el-icon>
            <span style="color: #f56c6c">二维码已过期</span>
          </div>

          <div style="display: flex; gap: 10px">
            <el-button
              v-if="state.loginStatus === 'expired' || state.loginStatus === 'error'"
              type="primary"
              @click="onRefreshQrCode()"
            >
              刷新二维码
            </el-button>
            <el-button @click="onCloseQrLogin()">关闭</el-button>
          </div>
        </div>
      </c_popup>
    </transition>

    <!-- ===== 红冲弹窗 ===== -->
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showRedDialog"
        title="发票红冲"
        width="600px"
        @close="state.showRedDialog = false"
      >
        <div class="detailBox">
          <ul class="detailContent">
            <el-form
              :model="state.redForm"
              label-width="120px"
              style="width: 80%"
            >
              <el-form-item label="蓝票发票号码">
                <el-input
                  v-model="state.redForm.originalInvoiceNo"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="红冲类型">
                <el-radio-group v-model="state.redForm.isFullRed">
                  <el-radio :label="true">全额红冲</el-radio>
                  <el-radio :label="false">部分红冲</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="!state.redForm.isFullRed"
                label="红冲项目名称"
                prop="itemName"
              >
                <el-input
                  v-model="state.redForm.itemName"
                  placeholder="请输入红冲项目名称"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-if="!state.redForm.isFullRed"
                label="红冲金额"
                prop="amount"
              >
                <el-input-number
                  v-model="state.redForm.amount"
                  :min="0"
                  :max="state.redForm.maxAmount"
                  :precision="2"
                  style="width: 100%"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="红冲原因">
                <el-radio-group v-model="state.redForm.reason">
                  <el-radio label="01">开票有误</el-radio>
                  <el-radio label="02">销货退回</el-radio>
                  <el-radio label="03">服务中止</el-radio>
                  <el-radio label="04">折扣折让</el-radio>
                </el-radio-group>
              </el-form-item>

              <!-- 红冲进度 -->
              <el-form-item v-if="state.redStep" label="红冲进度">
                <el-steps :active="state.redStep" align-center finish-status="success">
                  <el-step title="申请红字信息表" />
                  <el-step title="开具红字发票" />
                  <el-step title="更新状态" />
                </el-steps>
              </el-form-item>
              <el-form-item v-if="state.redResult" label="结果">
                <el-alert
                  :title="state.redResult"
                  :type="state.redSuccess ? 'success' : 'error'"
                  :closable="false"
                  show-icon
                />
              </el-form-item>
            </el-form>
          </ul>
          <ul class="detailBtn">
            <el-button
              type="primary"
              @click="onConfirmRed()"
              :loading="state.redSubmitting"
            >
              确认红冲
            </el-button>
            <el-button @click="state.showRedDialog = false">取消</el-button>
          </ul>
        </div>
      </c_popup>
    </transition>

    <!-- ===== 换开发票弹窗 ===== -->
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showHuanKaiDialog"
        title="换开发票"
        width="650px"
        @close="state.showHuanKaiDialog = false"
      >
        <div class="detailBox">
          <ul class="detailContent">
            <el-form
              :model="state.huanKaiForm"
              label-width="120px"
              ref="domHuanKaiForm"
              :rules="state.huanKaiRules"
            >
              <el-form-item label="原发票号码">
                <el-input :model-value="state.huanKaiForm.yuanFaPiaoHaoMa" disabled />
              </el-form-item>
              <el-form-item label="抬头类型" prop="TouTaiLx">
                <el-radio-group v-model="state.huanKaiForm.TouTaiLx">
                  <el-radio :label="1">个人</el-radio>
                  <el-radio :label="2">企业</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="购方名称" prop="GouFangMingCheng">
                <el-input
                  v-model="state.huanKaiForm.GouFangMingCheng"
                  placeholder="请输入购方名称/抬头名称"
                  maxlength="250"
                />
              </el-form-item>
              <el-form-item
                v-if="state.huanKaiForm.TouTaiLx === 2"
                label="购方税号"
                prop="GouFangShuiHao"
              >
                <el-input
                  v-model="state.huanKaiForm.GouFangShuiHao"
                  placeholder="请输入纳税人识别号"
                  maxlength="50"
                />
              </el-form-item>
              <el-form-item label="地址电话" prop="GouFangDiZhiDianHua">
                <el-input
                  v-model="state.huanKaiForm.GouFangDiZhiDianHua"
                  placeholder="请输入地址电话（可选）"
                  maxlength="200"
                />
              </el-form-item>
              <el-form-item label="银行账号" prop="GouFangYinHangZhangHao">
                <el-input
                  v-model="state.huanKaiForm.GouFangYinHangZhangHao"
                  placeholder="请输入银行账号（可选）"
                  maxlength="50"
                />
              </el-form-item>
              <el-form-item label="发票类型" prop="FaPiaoLeiXingDaiMa">
                <el-radio-group v-model="state.huanKaiForm.FaPiaoLeiXingDaiMa">
                  <el-radio label="030">数电普票</el-radio>
                  <el-radio label="032">数电专票</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="备注" prop="BeiZhu">
                <el-input
                  v-model="state.huanKaiForm.BeiZhu"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入备注（可选）"
                  maxlength="200"
                />
              </el-form-item>
              <el-form-item label="原发票信息">
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="金额">{{ state.huanKaiForm.yuanHeJiJinE }}</el-descriptions-item>
                  <el-descriptions-item label="税额">{{ state.huanKaiForm.yuanHeJiShuiE }}</el-descriptions-item>
                  <el-descriptions-item label="价税合计">{{ state.huanKaiForm.yuanJiaShuiHeJi }}</el-descriptions-item>
                </el-descriptions>
              </el-form-item>
            </el-form>
          </ul>
          <ul class="detailBtn">
            <el-button
              type="primary"
              :loading="state.huanKaiSubmitting"
              @click="onHuanKaiSubmit"
            >
              提交换开申请
            </el-button>
            <el-button @click="state.showHuanKaiDialog = false">取消</el-button>
          </ul>
        </div>
      </c_popup>
    </transition>

    <!-- ===== 开票详情弹窗 ===== -->
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showDetail"
        title="开票详情"
        width="800px"
        @close="state.showDetail = false"
      >
        <div class="detailBox">
          <ul class="detailContent">
            <div class="infoBox" style="margin-bottom: 15px">
              <ul>
                <li>
                  <ul class="title"><li>发票流水号</li></ul>
                  <ul class="content">{{ state.detailData.FaPiaoLiuShuiHao || '-' }}</ul>
                </li>
                <li>
                  <ul class="title"><li>状态</li></ul>
                  <ul class="content">
                    <el-tag
                      v-if="state.detailData.ZhuangTai === 0"
                      type="info"
                      size="small"
                    >待开票</el-tag>
                    <el-tag
                      v-else-if="state.detailData.ZhuangTai === 2"
                      type="success"
                      size="small"
                    >已开票</el-tag>
                    <el-tag
                      v-else-if="state.detailData.ZhuangTai === 3"
                      type="danger"
                      size="small"
                    >开票失败</el-tag>
                    <el-tag v-else type="warning" size="small">其他</el-tag>
                  </ul>
                </li>
              </ul>
              <ul>
                <li>
                  <ul class="title"><li>购方名称</li></ul>
                  <ul class="content">{{ state.detailData.GouFangMingCheng || '-' }}</ul>
                </li>
                <li>
                  <ul class="title"><li>购方税号</li></ul>
                  <ul class="content">{{ state.detailData.GouFangShuiHao || '-' }}</ul>
                </li>
              </ul>
              <ul>
                <li>
                  <ul class="title"><li>关联订单号</li></ul>
                  <ul class="content">{{ state.detailData.GuanLianDingDanHao || '-' }}</ul>
                </li>
                <li>
                  <ul class="title"><li>发票抬头名称</li></ul>
                  <ul class="content">{{ state.detailData.FaPiaoTouTai?.Mc || '-' }}</ul>
                </li>
              </ul>
              <ul>
                <li>
                  <ul class="title"><li>发票号码</li></ul>
                  <ul class="content">{{ state.detailData.FanHuiFaPiaoHaoMa || '-' }}</ul>
                </li>
                <li>
                  <ul class="title"><li>价税合计</li></ul>
                  <ul class="content">¥{{ $priceFormat(state.detailData.JiaShuiHeJi) }}</ul>
                </li>
              </ul>
              <ul>
                <li>
                  <ul class="title"><li>创建人</li></ul>
                  <ul class="content">{{ state.detailData.CjrXm || '-' }}</ul>
                </li>
                <li>
                  <ul class="title"><li>创建时间</li></ul>
                  <ul class="content">{{ state.detailData.Cjsj || '-' }}</ul>
                </li>
              </ul>
              <ul v-if="state.detailData.ShiBaiYuanYin">
                <li>
                  <ul class="title"><li>失败原因</li></ul>
                  <ul class="content" style="color: #f56c6c">{{ state.detailData.ShiBaiYuanYin }}</ul>
                </li>
              </ul>
            </div>

            <!-- 历史发票记录（同订单号） -->
            <div
              v-if="state.detailHistoryRecords && state.detailHistoryRecords.length > 0"
              class="history-section"
            >
              <div class="history-section-header">
                <span class="hs-title">关联历史发票</span>
                <el-tag size="small" type="info">{{ state.detailHistoryRecords.length }}条</el-tag>
              </div>
              <el-table
                :data="state.detailHistoryRecords"
                size="small"
                border
                style="width: 100%"
              >
                <el-table-column label="发票号码" min-width="160">
                  <template #default="{ row: hr }">
                    {{ hr.FanHuiFaPiaoHaoMa || '-' }}
                  </template>
                </el-table-column>
                <el-table-column label="状态" width="90" align="center">
                  <template #default="{ row: hr }">
                    <el-tag
                      v-if="hr.ZhuangTai === 0"
                      type="info"
                      size="small"
                    >待开票</el-tag>
                    <el-tag
                      v-else-if="hr.ZhuangTai === 1"
                      type="warning"
                      size="small"
                    >开票中</el-tag>
                    <el-tag
                      v-else-if="hr.ZhuangTai === 2"
                      type="success"
                      size="small"
                    >已开票</el-tag>
                    <el-tag
                      v-else-if="hr.ZhuangTai === 3"
                      type="danger"
                      size="small"
                    >失败</el-tag>
                    <el-tag
                      v-else-if="hr.ZhuangTai === 4"
                      type="warning"
                      size="small"
                    >已红冲</el-tag>
                    <el-tag
                      v-else-if="hr.ZhuangTai === 5"
                      type="danger"
                      size="small"
                    >红冲失败</el-tag>
                    <el-tag v-else size="small" type="info">未知</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="价税合计" width="110" align="right">
                  <template #default="{ row: hr }">
                    ¥{{ $priceFormat(hr.JiaShuiHeJi) }}
                  </template>
                </el-table-column>
                <el-table-column label="创建时间" width="160" align="center">
                  <template #default="{ row: hr }">
                    {{ hr.Cjsj || '-' }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </ul>
        </div>
      </c_popup>
    </transition>

    <!-- ===== 下载弹窗 ===== -->
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showDownload"
        title="下载发票版式文件"
        width="450px"
        @close="state.showDownload = false"
      >
        <div
          style="
            padding: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 15px;
          "
        >
          <div style="font-size: 14px; margin-bottom: 10px">
            <span style="font-weight: 600">发票号码：</span>
            {{ state.downloadInvoiceNo || '-' }}
          </div>
          <el-button
            type="primary"
            style="width: 200px"
            :loading="state.downloadLoading === 'pdf'"
            @click="onDownloadByFormat('pdf')"
          >
            <el-icon style="margin-right: 5px"><Document /></el-icon>
            下载 PDF 版式文件
          </el-button>
          <el-button
            type="success"
            style="width: 200px"
            :loading="state.downloadLoading === 'ofd'"
            @click="onDownloadByFormat('ofd')"
          >
            <el-icon style="margin-right: 5px"><Files /></el-icon>
            下载 OFD 版式文件
          </el-button>
          <el-button
            type="warning"
            style="width: 200px"
            :loading="state.downloadLoading === 'xml'"
            @click="onDownloadByFormat('xml')"
          >
            <el-icon style="margin-right: 5px"><DataAnalysis /></el-icon>
            下载 XML 版式文件
          </el-button>
        </div>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, onUnmounted, reactive, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import {
  shudiandianfapiao_records,
  shudiandianfapiao_detail,
  shudiandianfapiao_authstatus,
  shudiandianfapiao_logout,
  shudiandianfapiao_getqrcode,
  shudiandianfapiao_checklogin,
  shudiandianfapiao_scanresult,
  shudiandianfapiao_request_invoice,
  shudiandianfapiao_query_result,
  shudiandianfapiao_download,
  shudiandianfapiao_apply_red,
  shudiandianfapiao_open_red,
  shudiandianfapiao_huan_kai,
} from "@/http/api";

export default {
  setup() {
    const domTable = ref(null);

    const API_CONFIG_ID = 0; // 默认配置Id（配置从appsettings读取）

    const state = reactive({
      // 登录相关
      isLoggedIn: false,
      accountId: "",
      logoutLoading: false,

      // 查询参数
      params: {
        PageSize: 20,
        PageIndex: 1,
        Order: "Id",
        Asc: false,
        Params: {},
      },
      dateRange: [],
      totalCount: 0,

      // 统计
      stats: [
        { key: "all", label: "全部", count: 0, color: "#409eff" },
        { key: 0, label: "待开票", count: 0, color: "#909399" },
        { key: 1, label: "开票中", count: 0, color: "#e6a23c" },
        { key: 2, label: "已开票", count: 0, color: "#67c23a" },
        { key: 3, label: "开票失败", count: 0, color: "#f56c6c" },
      ],

      // 表格选择
      selection: [],

      // 批量开票
      batchIssuing: false,

      // 扫码登录
      showQrLogin: false,
      qrcodeLoading: false,
      qrcodeUrl: "",
      loginStatus: "",
      loginError: "",
      loginTaskId: "",
      loginQrcodeId: "",
      _pollTimer: null,

      // 开票轮询
      _invoicePollTimer: null,

      // 红冲
      showRedDialog: false,
      redForm: {},
      redStep: 0,
      redResult: "",
      redSuccess: false,
      redSubmitting: false,

      // 换开
      showHuanKaiDialog: false,
      huanKaiYuanJiLuId: 0,
      huanKaiForm: {
        yuanFaPiaoHaoMa: "",
        yuanHeJiJinE: "",
        yuanHeJiShuiE: "",
        yuanJiaShuiHeJi: "",
        TouTaiLx: 2,
        GouFangMingCheng: "",
        GouFangShuiHao: "",
        GouFangDiZhiDianHua: "",
        GouFangYinHangZhangHao: "",
        FaPiaoLeiXingDaiMa: "82",
        BeiZhu: "",
      },
      huanKaiRules: {
        GouFangMingCheng: [
          { required: true, message: "请输入购方名称", trigger: "blur" },
        ],
        GouFangShuiHao: [],
        TouTaiLx: [
          { required: true, message: "请选择抬头类型", trigger: "change" },
        ],
      },
      huanKaiSubmitting: false,

      // 详情
      showDetail: false,
      detailData: {},
      detailHistoryRecords: [],

      // 下载
      showDownload: false,
      downloadInvoiceNo: "",
      downloadRecordId: 0,
      downloadKaiPiaoRiQi: "",
      downloadLoading: "",
    });

    // ==================== 生命周期 ====================
    onMounted(() => {
      checkLoginStatus();
      onLoad();
      shudiandianfapiao_checklogin({ ApiConfigId: API_CONFIG_ID })
        .then((res) => {
          if (res.status === 200 && res.data?.Data?.IsValid) {
            // IsValid = true，登录有效
            state.isLoggedIn = true;
            state.accountId = res.data?.Data?.Nsrsbh ?? "";
          } else {
            // IsValid = false，登录已失效
            state.isLoggedIn = false;
            state.accountId = "";
          }
        })
        .catch(() => {
          state.isLoggedIn = false;
          state.accountId = "";
        });
    });

    onUnmounted(() => {
      clearAllTimers();
    });

    // ==================== 登录 ====================
    const checkLoginStatus = async () => {
      try {
        const res = await shudiandianfapiao_authstatus(API_CONFIG_ID);
        if (res.status === 200) {
          // AuthStatus 直接返回: { IsLoggedIn, Nsrsbh, EnterpriseName, DiQuDaiMa }
          state.isLoggedIn = res.data?.IsLoggedIn ?? false;
          state.accountId = res.data?.Nsrsbh ?? "";
        }
      } catch {
        state.isLoggedIn = false;
      }
    };

    const onRefreshLogin = () => {
      checkLoginStatus();
    };

    const onLogout = async () => {
      try {
        state.logoutLoading = true;
        await shudiandianfapiao_logout(API_CONFIG_ID);
        state.isLoggedIn = false;
        state.accountId = "";
        ElMessage.success("已退出登录");
      } catch {
        ElMessage.error("退出登录失败");
      } finally {
        state.logoutLoading = false;
      }
    };

    // ==================== 扫码登录 ====================
    const onOpenQrLogin = async () => {
      state.showQrLogin = true;
      state.loginStatus = "";
      state.loginError = "";
      await getQrCode();
    };

    const getQrCode = async () => {
      try {
        state.qrcodeLoading = true;
        state.loginStatus = "loading";
        const res = await shudiandianfapiao_getqrcode({
          ApiConfigId: API_CONFIG_ID,
        });
        if (res.status === 200) {
          // 后端返回: { Success, Message, Data: { QrcodeImageUrl, TaskId, QrcodeId } }
          const resultData = res.data?.Data;
          state.qrcodeUrl = resultData?.QrcodeImageUrl ?? "";
          state.loginTaskId = resultData?.TaskId ?? "";
          state.loginQrcodeId = resultData?.QrcodeId ?? "";
          state.qrcodeLoading = false;
          // 开始轮询扫码结果
          state.loginStatus = "waiting";
          startPollingResult();
        }
      } catch (err) {
        state.qrcodeLoading = false;
        state.loginStatus = "error";
        state.loginError = "获取二维码失败，" + (err?.message || "");
      }
    };

    const startPollingResult = () => {
      clearPollTimer();
      state._pollTimer = setInterval(async () => {
        if (!state.showQrLogin) {
          clearPollTimer();
          return;
        }
        try {
          const res = await shudiandianfapiao_scanresult({
            ApiConfigId: API_CONFIG_ID,
            TaskId: state.loginTaskId,
            QrcodeId: state.loginQrcodeId,
          });
          if (res.status === 200 && res.data?.Success) {
            // 后端返回: { Success, Message, Data: { Status, AccountId, ... } }
            const resultData = res.data?.Data;
            const status = resultData?.Status ?? "";
            state.accountId = resultData?.AccountId ?? "";
            if (status === "scanned") {
              state.loginStatus = "scanned";
            } else if (status === "confirmed") {
              state.loginStatus = "success";
              state.isLoggedIn = true;
              clearPollTimer();
              setTimeout(() => {
                state.showQrLogin = false;
                ElMessage.success("扫码登录成功！");
              }, 1500);
            } else if (status === "expired") {
              state.loginStatus = "expired";
              clearPollTimer();
            }
          } else if (res.status === 200 && res.data?.Success === false) {
            // Success 为 false 时静默处理，仅输出日志
            console.log("扫码轮询异常：" + (res.data?.Message || "未知错误"));
          }
        } catch {
          // 轮询错误静默处理
        }
      }, 3000);
    };

    const onRefreshQrCode = () => {
      clearPollTimer();
      state.loginStatus = "";
      getQrCode();
    };

    const onCloseQrLogin = () => {
      clearPollTimer();
      state.showQrLogin = false;
      state.qrcodeUrl = "";
    };

    const clearPollTimer = () => {
      if (state._pollTimer) {
        clearInterval(state._pollTimer);
        state._pollTimer = null;
      }
    };

    const clearAllTimers = () => {
      clearPollTimer();
      if (state._invoicePollTimer) {
        clearInterval(state._invoicePollTimer);
        state._invoicePollTimer = null;
      }
    };

    // ==================== 列表查询 ====================
    const onLoad = () => {
      delete state.tableData;
      shudiandianfapiao_records(state.params).then((res) => {
        if (res.status === 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
          updateStats(list);
        }
      });
    };

    const updateStats = (list) => {
      // 简单统计：从当前页数据展示（实际生产环境应调用统计接口获取全量统计）
      if (!Array.isArray(list)) return;
      const allCount = state.totalCount;
      state.stats[0].count = allCount;
      state.stats[1].count = list.filter((r) => r.ZhuangTai === 0).length;
      state.stats[2].count = list.filter((r) => r.ZhuangTai === 1).length;
      state.stats[3].count = list.filter((r) => r.ZhuangTai === 2).length;
      state.stats[4].count = list.filter((r) => r.ZhuangTai === 3).length;
    };

    const onSortChange = (column) => {
      state.params.Order = column.prop;
      state.params.Asc = column.order === "ascending";
      onLoad();
    };

    const onReset = () => {
      state.dateRange = [];
      Object.assign(state, {
        params: {
          PageSize: 20,
          PageIndex: 1,
          Order: "Id",
          Asc: false,
          Params: {},
        },
      });
      onLoad();
    };

    const onDateRangeChange = () => {
      if (state.dateRange && state.dateRange.length === 2) {
        state.params.Params.KaiPiaoShiJianStart = state.dateRange[0];
        state.params.Params.KaiPiaoShiJianEnd = state.dateRange[1];
      } else {
        delete state.params.Params.KaiPiaoShiJianStart;
        delete state.params.Params.KaiPiaoShiJianEnd;
      }
      onLoad();
    };

    const onStatFilter = (key) => {
      if (key === "all") {
        delete state.params.Params.ZhuangTai;
      } else {
        state.params.Params.ZhuangTai = key;
      }
      state.params.PageIndex = 1;
      onLoad();
    };

    const onSelectionChange = (rows) => {
      state.selection = rows;
    };

    // ==================== 开票 ====================
    const onIssueSingle = (row) => {
      // 列表数据中已有足够信息（金额、流水号、抬头等），直接用 BlueTicketRequest 格式发起
      ElMessageBox.confirm("确定要为该记录发起开票吗？", "提示", {
        confirmButtonText: "确定开票",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const req = {
          ApiConfigId: API_CONFIG_ID,
          Fpqqlsh: row.FaPiaoLiuShuiHao,
          Fplxdm: String(row.FaPiaoLeiXingDaiMa || 82),
          Ghdwmc: row.GouFangMingCheng || "",
          Ghdwsbh: row.GouFangShuiHao || undefined,
          Hjje: String(row.HeJiJinE || 0),
          Hjse: String(row.HeJiShuiE || 0),
          Jshj: String(row.JiaShuiHeJi || 0),
          Kpr: row.KaiPiaoRen || undefined,
          Bz: row.BeiZhu || undefined,
          GuanLianDingDanHao: row.GuanLianDingDanHao || undefined,
          FaPiaoTouTaiId: row.FaPiaoTouTaiId || undefined,
          Fyxm: [{
            Fphxz: 0,
            Spmc: "商品",
            Xmmc: "商品",
            Je: parseFloat(row.HeJiJinE || 0),
            Sl: "1",
            Se: parseFloat(row.HeJiShuiE || 0),
            Hsbz: "1",
            Spbm: "1090305010000000000",
            Ggxh: "",
            Dw: "个",
            Slv: "0.06",
            Dj: String(row.HeJiJinE || 0)
          }]
        };

        try {
          const res = await shudiandianfapiao_request_invoice(req);
          if (res.status === 200 && res.data?.Success) {
            // 后端返回: { Success, Message, Data: { RequestId, Fphm, RequestId, ... } }
            const requestId = res.data?.Data?.RequestId ?? res.data?.Data?.requestId;
            ElMessage.success("开票请求已提交，正在查询结果...");
            // 启动轮询查询结果
            pollInvoiceResult(row.Id, requestId);
          } else {
            ElMessage.error(res.data?.Message || "开票请求失败");
          }
        } catch (err) {
          ElMessage.error("开票请求异常：" + (err?.message || ""));
        }
      }).catch(() => {});
    };

    const onBatchIssue = () => {
      if (state.selection.length === 0) {
        ElMessage.warning("请先选择需要开票的记录");
        return;
      }
      const pendingList = state.selection.filter(
        (r) => r.ZhuangTai === 0 || r.ZhuangTai === 3
      );
      if (pendingList.length === 0) {
        ElMessage.warning("所选记录中没有待开票或开票失败的记录");
        return;
      }

      ElMessageBox.confirm(
        `确认要为选中的 ${pendingList.length} 条记录批量开票吗？`,
        "批量开票",
        { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
      ).then(async () => {
        state.batchIssuing = true;
        let successCount = 0;
        let failCount = 0;

        for (const row of pendingList) {
          try {
            const req = {
              ApiConfigId: API_CONFIG_ID,
              Fpqqlsh: row.FaPiaoLiuShuiHao,
              Fplxdm: String(row.FaPiaoLeiXingDaiMa || 82),
              Ghdwmc: row.GouFangMingCheng || "",
              Ghdwsbh: row.GouFangShuiHao || undefined,
              Hjje: String(row.HeJiJinE || 0),
              Hjse: String(row.HeJiShuiE || 0),
              Jshj: String(row.JiaShuiHeJi || 0),
              Kpr: row.KaiPiaoRen || undefined,
              Fyxm: [{
                Fphxz: 0,
                Spmc: "商品",
                Xmmc: "商品",
                Je: parseFloat(row.HeJiJinE || 0),
                Sl: "1",
                Se: parseFloat(row.HeJiShuiE || 0),
                Hsbz: "1",
                Spbm: "1090305010000000000",
                Ggxh: "",
                Dw: "个",
                Slv: "0.06",
                Dj: String(row.HeJiJinE || 0)
              }]
            };
            const res = await shudiandianfapiao_request_invoice(req);
            if (res.status === 200 && res.data?.Success) {
              successCount++;
            } else {
              failCount++;
            }
          } catch {
            failCount++;
          }
          // 批量开票添加间隔，避免请求过快
          await new Promise((r) => setTimeout(r, 800));
        }

        state.batchIssuing = false;
        ElMessage.success(
          `批量开票完成：成功 ${successCount} 条，失败 ${failCount} 条`
        );
        onLoad();
      }).catch(() => {});
    };

    const pollInvoiceResult = (recordId, requestId) => {
      if (!requestId) return;
      let retryCount = 0;
      const maxRetry = 20;

      state._invoicePollTimer = setInterval(async () => {
        retryCount++;
        try {
          const res = await shudiandianfapiao_query_result({
            ApiConfigId: API_CONFIG_ID,
            RequestId: requestId,
          });
          if (res.status === 200) {
            // 后端返回: { Success, Message, Data: { Status, Fphm, FailReason, ... } }
            const resultData = res.data?.Data;
            const status = resultData?.Status ?? res.data?.status ?? "";
            if (status === "success") {
              clearInterval(state._invoicePollTimer);
              state._invoicePollTimer = null;
              ElMessage.success("开票成功！发票号码：" + (resultData?.Fphm || ""));
              onLoad();
            } else if (status === "failed") {
              clearInterval(state._invoicePollTimer);
              state._invoicePollTimer = null;
              ElMessage.error("开票失败：" + (resultData?.FailReason || "未知错误"));
              onLoad();
            }
          }
        } catch {
          // 轮询异常静默
        }
        if (retryCount >= maxRetry) {
          clearInterval(state._invoicePollTimer);
          state._invoicePollTimer = null;
          ElMessage.warning("开票结果查询超时，请稍后手动刷新列表查看结果");
          onLoad();
        }
      }, 5000);
    };

    // ==================== 红冲 ====================
    const onRedInvoice = (row) => {
      state.showRedDialog = true;
      state.redStep = 0;
      state.redResult = "";
      state.redSuccess = false;
      state.redForm = {
        recordId: row.Id,
        originalInvoiceNo: row.FanHuiFaPiaoHaoMa || "",
        originalInvoiceType: String(row.FaPiaoLeiXingDaiMa || 82),
        isFullRed: true,
        amount: 0,
        maxAmount: row.JiaShuiHeJi || 0,
        itemName: "",
        reason: "03",
      };
    };

    // ==================== 换开 ====================
    const domHuanKaiForm = ref(null);

    const onHuanKai = (row) => {
      state.huanKaiYuanJiLuId = row.Id;
      state.huanKaiForm = {
        yuanFaPiaoHaoMa: row.FanHuiFaPiaoHaoMa || "",
        yuanHeJiJinE: row.HeJiJinE || 0,
        yuanHeJiShuiE: row.HeJiShuiE || 0,
        yuanJiaShuiHeJi: row.JiaShuiHeJi || 0,
        TouTaiLx: row.GouFangShuiHao ? 2 : 1,
        GouFangMingCheng: row.GouFangMingCheng || "",
        GouFangShuiHao: row.GouFangShuiHao || "",
        GouFangDiZhiDianHua: row.GouFangDiZhiDianHua || "",
        GouFangYinHangZhangHao: row.GouFangYinHangZhangHao || "",
        FaPiaoLeiXingDaiMa: String(row.FaPiaoLeiXingDaiMa || 82),
        BeiZhu: "",
      };
      state.showHuanKaiDialog = true;
    };

    const onHuanKaiSubmit = () => {
      domHuanKaiForm.value.validate(async (valid) => {
        if (!valid) return;
        state.huanKaiSubmitting = true;
        try {
          const res = await shudiandianfapiao_huan_kai(state.huanKaiYuanJiLuId, {
            GouFangMingCheng: state.huanKaiForm.GouFangMingCheng,
            GouFangShuiHao: state.huanKaiForm.GouFangShuiHao || null,
            GouFangDiZhiDianHua: state.huanKaiForm.GouFangDiZhiDianHua || null,
            GouFangYinHangZhangHao: state.huanKaiForm.GouFangYinHangZhangHao || null,
            TouTaiLx: state.huanKaiForm.TouTaiLx,
            FaPiaoLeiXingDaiMa: state.huanKaiForm.FaPiaoLeiXingDaiMa,
            BeiZhu: state.huanKaiForm.BeiZhu || null,
          });
          if (res.status === 200) {
            ElMessage.success(res.data?.Message || "换开申请已创建");
            state.showHuanKaiDialog = false;
            onLoad();
          }
        } catch (err) {
          ElMessage.error("换开发起失败：" + (err?.message || ""));
        } finally {
          state.huanKaiSubmitting = false;
        }
      });
    };

    const onConfirmRed = async () => {
      if (!state.redForm.originalInvoiceNo) {
        ElMessage.warning("缺少原发票号码");
        return;
      }
      state.redSubmitting = true;
      state.redStep = 0;
      state.redResult = "";

      try {
        // 步骤1：申请红字信息表
        state.redStep = 1;
        const applyRes = await shudiandianfapiao_apply_red({
          ApiConfigId: API_CONFIG_ID,
          YuanFphm: state.redForm.originalInvoiceNo,
          YuanFpLx:
            state.redForm.originalInvoiceType === "81" ? "010" : "030",
          IsFullRed: state.redForm.isFullRed,
          HongChongYuanYin: state.redForm.reason,
          ChongHongXiangMuMingCheng: state.redForm.itemName || undefined,
        });

        // 后端返回: { Success, Message, Data: { Hzuuid, ... } }
        if (applyRes.status !== 200 || !applyRes.data?.Success) {
          state.redStep = 0;
          state.redResult = applyRes.data?.Message || "红字信息表申请失败";
          state.redSuccess = false;
          state.redSubmitting = false;
          return;
        }

        const hzuuid =
          applyRes.data?.Data?.Hzuuid ?? applyRes.data?.Data?.hzuuid;
        if (!hzuuid) {
          state.redStep = 0;
          state.redResult = "未获取到红字UUID";
          state.redSuccess = false;
          state.redSubmitting = false;
          return;
        }

        // 步骤2：开具红字发票
        state.redStep = 2;
        const openRes = await shudiandianfapiao_open_red({
          ApiConfigId: API_CONFIG_ID,
          Hzuuid: hzuuid,
        });

        if (openRes.status !== 200 || !openRes.data?.Success) {
          state.redStep = 1;
          state.redResult =
            "红字信息表已申请，但开具红票失败：" +
            (openRes.data?.Message || "未知错误");
          state.redSuccess = false;
          state.redSubmitting = false;
          return;
        }

        // 步骤3：完成
        state.redStep = 3;
        state.redResult = "红冲成功！";
        state.redSuccess = true;
        state.redSubmitting = false;
        setTimeout(() => {
          state.showRedDialog = false;
          onLoad();
        }, 2000);
      } catch (err) {
        state.redStep = 0;
        state.redResult = "红冲异常：" + (err?.message || "");
        state.redSuccess = false;
        state.redSubmitting = false;
      }
    };

    // ==================== 下载 ====================
    const onDownload = (row) => {
      state.showDownload = true;
      state.downloadInvoiceNo = row.FanHuiFaPiaoHaoMa || row.FaPiaoLiuShuiHao;
      state.downloadRecordId = row.Id;
      state.downloadKaiPiaoRiQi = row.FanHuiKaiPiaoRiQi || "";
      state.downloadLoading = "";
    };

    const onBatchDownload = () => {
      if (state.selection.length === 0) {
        ElMessage.warning("请先选择需要下载的记录");
        return;
      }
      const validList = state.selection.filter(
        (r) => r.ZhuangTai === 2 && r.FanHuiFaPiaoHaoMa
      );
      if (validList.length === 0) {
        ElMessage.warning("所选记录中没有已开票且含发票号码的记录");
        return;
      }
      // 逐一下载（浏览器限制，批量下载可后续改为打包zip）
      validList.forEach((row, idx) => {
        setTimeout(() => onDownloadByFormat("pdf", row), idx * 500);
      });
    };

    const onDownloadByFormat = async (format, overrideRow) => {
      const row = overrideRow || {
        FanHuiFaPiaoHaoMa: state.downloadInvoiceNo,
        Id: state.downloadRecordId,
        FanHuiKaiPiaoRiQi: state.downloadKaiPiaoRiQi,
      };
      if (!row.FanHuiFaPiaoHaoMa) {
        ElMessage.warning("该记录暂无发票号码，无法下载");
        return;
      }
      if (!row.FanHuiKaiPiaoRiQi) {
        ElMessage.warning("该记录暂无开票日期，无法下载");
        return;
      }

      state.downloadLoading = format;
      try {
        const res = await shudiandianfapiao_download({
          ApiConfigId: API_CONFIG_ID,
          Fphm: row.FanHuiFaPiaoHaoMa,
          Kprq: row.FanHuiKaiPiaoRiQi,
          Format: format,
        });
        if (res.status === 200) {
          // 后端返回: { Success, Message, Data: { FileList: [{ Url, Wjgs, Fphm, Kprq }] } }
          const resultData = res.data?.Data;
          const fileUrl = resultData?.FileList?.[0]?.Url ?? "";
          if (fileUrl) {
            window.open(fileUrl, "_blank");
            ElMessage.success(format.toUpperCase() + " 版式文件已打开下载");
          } else {
            ElMessage.error("未获取到下载地址");
          }
        } else {
          ElMessage.error(res.data?.Message || "下载失败");
        }
      } catch (err) {
        ElMessage.error("下载异常：" + (err?.message || ""));
      } finally {
        state.downloadLoading = "";
      }
    };

    // ==================== 详情 ====================
    const onViewDetail = async (row) => {
      try {
        state.showDetail = true;
        const res = await shudiandianfapiao_detail(row.Id);
        if (res.status === 200) {
          // API 返回 { record, historyRecords }，兼容旧格式直接返回实体
          const apiData = res.data || {};
          // record 字段存在 → 新格式；否则兼容旧格式（整个 data 即为记录实体）
          state.detailData = { ...(apiData.record || apiData) } || { ...row };
          state.detailHistoryRecords = apiData.historyRecords || [];
        } else {
          state.detailData = { ...row };
          state.detailHistoryRecords = [];
        }
      } catch {
        state.detailData = { ...row };
        state.detailHistoryRecords = [];
      }
    };

    return {
      state,
      domTable,
      domHuanKaiForm,
      onLoad,
      onSortChange,
      onReset,
      onStatFilter,
      onSelectionChange,
      onIssueSingle,
      onBatchIssue,
      onRedInvoice,
      onHuanKai,
      onHuanKaiSubmit,
      onConfirmRed,
      onDownload,
      onBatchDownload,
      onDownloadByFormat,
      onViewDetail,
      onLogout,
      onRefreshLogin,
      onOpenQrLogin,
      onCloseQrLogin,
      onRefreshQrCode,
      onDateRangeChange,
    };
  },
};
</script>

<style scoped>
.statsBox {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 10px;
}

.statCard {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-top: 3px solid #409eff;
  border-radius: 6px;
  padding: 12px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.statCard:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.statNum {
  font-size: 22px;
  font-weight: 700;
}

.statLabel {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

/* 操作按钮列覆盖样式 */
:deep(.tabBtn .el-button) {
  padding: 0 6px !important;
}

.title{
    width: 85px;
    padding-right: 5px;
}

.history-section {
  margin-top: 16px;
  border-top: 1px dashed #e8e8e8;
  padding-top: 14px;
}

.history-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.hs-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
</style>
